import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { EmbryoService } from "../../Services/Embryo.service";
import { Router } from "@angular/router";
import { LoginUsersService } from "../../Services/login-users.service";
import { CheckoutService } from "../../Services/checkout.service";
import { HomePageService } from "../../Services/home-page.service";
import { Subscription } from "rxjs";
import { ReactivityService } from "../../Services/reactivity.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { NotificationsService } from "src/app/Services/notifications.service";

@Component({
    selector: "app-stars-list-menu",
    templateUrl: "./stars-list-menu.component.html",
    styleUrls: ["./stars-list-menu.component.scss"],
})
export class StarsListMenuComponent implements OnInit {
    @Input() lang: any;
    @ViewChild("menuTrigger", { static: false }) menuTrigger: any;
    currency = this.embryoService.currency;
    clonedProducts: Array<any> = [];
    isAuthUser: any;
    enteredMenu: boolean = false;
    subscription: Subscription;
    isMobile: any;
    environmentVariables: any;
    headerIconsColor: any;
    loyaltyData: any;
     changeIconFill:boolean = true;

    constructor(
        private embryoService: EmbryoService,
        private notificationsServices: NotificationsService,
        private reactivityService: ReactivityService,
        private pagesService: StaticPagesService,
        private router: Router
    ) {
        this.embryoService.getLoyaltyDataEmit().subscribe((res: any) => {
            this.loyaltyData = res;
        });
        this.pagesService.getenvConfig().subscribe((res: any) => {
            this.environmentVariables = res;
            this.headerIconsColor =
                this.environmentVariables.HEADER_ICONS_FILL_COLOR;
        });
        this.subscription = this.reactivityService.storeObserver$.subscribe(
            (data: any) => {
                setTimeout(() => {
                    this.isAuthUser = JSON.parse(
                        <string>localStorage.getItem("auth_user_crocs")
                    );
                }, 0);
            }
        );
    }

    ngOnInit() {
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
            navigator.userAgent
        );
        this.isAuthUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
    }

    toggleMenu(event: any, open: any) {
        if (!this.isMobile) {
            if (open) {
                event.stopPropagation();
                this.enteredMenu = false;
                this.menuTrigger.openMenu();
            } else {
                setTimeout(() => {
                    if (!this.enteredMenu) {
                        this.menuTrigger.closeMenu();
                    }
                }, 150);
            }
        }
    }

    closeMatMenu() {
        this.enteredMenu = false;
        this.menuTrigger.closeMenu();
    }

    checkUserGuest() {
        this.router.navigate(["/" + this.lang + "/account/your-points"]);
    }
}
